<template>
  <div id="app">
    <Header v-if="!isLoading" />
    <router-view/>

    <!--  Page Loading  -->
    <PageLoad v-if="isLoading" />

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import setting from '@/setting.js'
import Reset from '@/assets/css/reset.css'
import Default from '@/assets/css/default.css'
import Common from '@/assets/css/common.css'
import Header from '@/components/Header'
import PageLoad from '@/components/Loading'

export default {
  name: 'App',

  components: {
    PageLoad,
    setting,
    mapGetters,
    Reset,
    Default,
    Common,
    Header
  },

  data () {
    return {
      setting
    }
  },

  computed: {
    ...mapGetters(['isLoading'])
  }
}
</script>

<style lang="postcss" scoped>
  #app {
    width: 100%;
  }

  .main {
    min-height: calc(100vh - 50px);
    background-color: #fafafa !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: ease-out .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .check--footer {
    padding-bottom: 50px;
    &.footer--top {
      padding-bottom: 0;
      .main {
        padding-top: 100px!important;
      }
      .footer {
        top: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue